import React from "react";
import { Route } from "react-router-dom";
import AccessControl from "../../../components/utilities/Class/AccessControl";
import approval from "../../../containers/modules/user/approval";

export default function ApprovalRoute(props) {
  const { authUser } = props;
  return (
    <Route
      path="approval"
      index
      element={
        <AccessControl
          name={"User Approval List"}
          auth={authUser}
          component={approval}
        />
      }
    />
  );
}
